<!-- 组件说明 -->
<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
    class="recycle-bin-list"
    :immediate-check="false"
  >
    <div
      v-for="item in recycleBinList"
      :key="item.recommend.id"
      class="recycle"
    >
      <div class="recycle-info">
        <div class="recycle-left">
          <div class="">
            <span class="title">审核时间</span>
            <!-- <span class="info">{{ item.distributeDate }}</span> -->
            <span class="info">{{
              item.recommend.updateDate
                ? moment(item.recommend.updateDate).format("YYYY/MM/DD")
                : ""
            }}</span>
          </div>
          <div class="recycle-bottom">
            <span class="title title-weight">老业主</span>
            <span class="info re-user">{{ item.recommend.recUsername }}</span>
          </div>
        </div>
        <div class="recycle-right">
          <div class="">
            <span class="title">提交人</span>
            <span class="info four-words">{{
              item.recommend.distributeName
            }}</span>
          </div>
          <div class="recycle-bottom">
            <span class="title title-weight">新客户</span>
            <span class="info four-words">{{ item.recommend.presentee }}</span>
          </div>
        </div>
      </div>
      <div class="btn" @click="revert(item.recommend.id)">还原</div>
      <!-- loading -->
      <loading :show="loadingStatus"></loading>
    </div>
  </van-list>
</template>

<script>
import loading from "@/components/loading";

import { List as VanList, Toast } from "vant";
import moment from "moment";
export default {
  components: { VanList, loading },
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  data() {
    return {
      loadingStatus: false,
      recycleBinList: [],
      loading: false,
      finished: false,
      pageData: {
        size: 10,
        current: 1,
        projectCode: this.projectCode,
        orgCode: this.orgCode,
        // 客户状态
        statuses: 8,
        requestEntry: 1,
      },
      moment,
    };
  },
  methods: {
    onLoad() {
      if (!this.finished) {
        this.pageData.current += 1;
        this.getList();
      }
    },
    // 获取列表
    getList() {
      this.$api.recyclingList(this.pageData).then((res) => {
        if (res.status && res.code === "0000") {
          this.recycleBinList.push(...res.body.records);
          if (this.pageData.current >= res.body.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
        this.loading = false;
      });
    },
    revert(id) {
      this.loadingStatus = true;
      this.$api
        .revert({ recommendId: id })
        .then((res) => {
          if (res.status && res.code === "0000") {
            Toast.success("还原成功");
            this.clearData();
            this.getList();
            this.loadingStatus = false;
          }
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    // 清空数据
    clearData() {
      this.pageData.current = 1;
      this.recycleBinList = [];
      this.finished = true;
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.recycle-bin-list {
  margin-top: 24px;
  padding-bottom: 20px;
  .recycle {
    margin-bottom: 30px;
    width: 690px;
    height: 200px;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(164, 164, 164, 0.4);
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 20px 30px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    .recycle-info {
      width: 554px;
      .recycle-left {
        width: 280px;
        display: inline-block;
      }
      .recycle-right {
        width: 225px;
        margin-left: 6px;
        height: 100%;
        display: inline-block;
      }
      .recycle-bottom {
        margin-top: 60px;
      }
      .title {
        color: #666666;
      }
      .info {
        color: #333333;
        margin-left: 10px;
      }
      /* 老业主偏移距离不同 */
      .re-user {
        margin-left: 40px;
      }
      .title-weight {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      /* 做四字长度限制 */
      .four-words {
        /* overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: inline-block;
        width: 128px; */
      }
    }
    .btn {
      width: 96px;
      height: 56px;
      background: #0d9869;
      border-radius: 12px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 56px;
      text-align: center;
    }
  }
}
</style>
